<template>
  <div class="home">
    <div
      class="top"
      style="
        border-bottom: solid 3px #e3e3e3;
        box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
        position: relative;
        z-index: 3;
        background:#FFF;
      "
    >
      <div class="selectGrade">
        <div>
          <el-dropdown @command="handleCommand">
            <span
              class="el-dropdown-link"
              style="width: 120px; display: inline-block; text-align: right"
              >{{ choSectionName
              }}<i
                class="el-icon-arrow-down el-icon--right"
                style="color: #c5c5c5"
              ></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="a in sectionList"
                :command="a.id"
                :key="a.id"
                >{{ a.sectionName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <span style="margin: 0 25px; color: #c5c5c5">|</span>
          <span
            class="item_title"
            :class="{ item_active: choGrade == item.id }"
            v-for="(item, index) in gradeList"
            :key="index"
            @click="btnActive(item.id)"
            >{{ item.gradeName }}</span
          >
        </div>
      </div>
    </div>
    <div style="background: #fff">
      <el-carousel :height="430 + 'px'" :interval="5000" arrow="always">
        <el-carousel-item v-for="a in topBannerList" :key="a.id">
          <!-- <h3>{{123}}</h3> -->

          <!-- <div @click="jumpTo(a)" :style="{
              height: 430 + 'px',
              background:
                'url(' + a + ') no-repeat center center',
              position: 'relative',
              backgroundSize:100+'%'+100+'%'
            }"
          > -->
          <div @click="jumpTo(a)" :style="{
              height: 430 + 'px',
              background:
                'url(' + imgdizhi + a.imagePath + ') no-repeat center center',
              position: 'relative'
            }"
          >
          <img style="position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; max-width:100%; max-height:100%;" :src="imgdizhi+a.imagePath"> 
          </div>
          <!-- <div class="carousel_pos">
            <div :style="{height:height+'px'}" class="carousel_bgc"></div>
          </div> -->
          <!-- <img src="../../static/img/swper.png" alt=""> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 通知内容 -->
    <div class="marginAuto note">
      <el-carousel
        height="40px"
        indicator-position="none"
        arrow="never"
        direction="vertical"
      >
        <el-carousel-item v-for="(item, index3) in tongzhiList" :key="index3">
          <div class="Notice">
            <img class="laba" src="../../static/img/通知.png" alt="" />
            <span @click="goTongzhi" style="font-size: 14px">通知公告</span>
            <span style="font-size: 14px; margin: 0 10px">|</span>
            <span @click="goTongzhi">{{ item.title }}</span>
          </div>

        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 最新课程 -->
    <div class="marginAuto">
      <div class="title_con" style="padding: 15px">
        <div style="display: flex">
          <div class="title_l ys1">最新课程</div>
        </div>
        <div class="moreBt" @click="goKecheng">更多</div>
      </div>
      <div class="con_main">
        <div style="width: 20%" v-for="n in newList" :key="n.id">
          <Detail :mes="n"></Detail>
        </div>
      </div>
    </div>
    <!-- banner1 -->
    <div class="marginAuto">
      <div style="padding:10px">
        <el-carousel
          :height="140 + 'px'"
          :interval="5000"
          indicator-position="none"
          arrow="never"
        >
          <el-carousel-item
            v-for="(b, index1) in centerBannerList"
            :key="index1"
          >
            <div
              @click="jumpTo(b)"
              :style="{
                height: 140 + 'px',
                background:
                  'url(' + imgdizhi + b.imagePath + ') no-repeat center center',
                backgroundSize: 100 + '%',
              }"
            >
            <!-- <div
              @click="jumpTo(b)"
              :style="{
                height: 140 + 'px',
                background:
                  'url(' + b + ') no-repeat center center',
                backgroundSize: 100 + '%'+100 + '%',
              }"
            > -->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 最热课程 -->
    <div class="marginAuto">
      <div class="title_con" style="padding: 15px">
        <div style="display: flex">
          <div class="title_l ys2">最热课程</div>
        </div>
        <div class="moreBt" @click="goKecheng">更多</div>
      </div>
      <div class="con_main">
        <div style="width: 20%" v-for="h in hotList" :key="h.id">
          <Detail :mes="h"></Detail>
        </div>
      </div>
    </div>
    <!-- 家长学校 -->
    <div class="parents_channel" style="margin-bottom:15px">
      <div class="con_main">
        <div
          class="more_parent"
          @click="goParent"
        >
          更多
        </div>
        <div class="parents_main">
          <div class="parents_Title">
            <span>家长学校</span>
          </div>
          <div class="bgc_parent" style="overflow: hidden">
            <!-- <div class=""></div>
            <div class="top_parent">
              <span style="    color: #333;
    font-size: 15px;">让法治社会走进我们的生活群</span>
              <img class="img_parent" src="../../static/img/parent.png" alt="">
            </div> -->

            <el-carousel
              :interval="10000"
              :autoplay="false"
              indicator-position="bottom"
              arrow="never"
              @change="bianhua"
              type="card"
              height="230px"
            >
              <el-carousel-item
                v-for="(item, index2) in jiazhangfenleiList"
                :key="index2"
              >
                <div class="mesBox">
                  <h4>{{ item.speciaName }}</h4>
                  <div class="imgBox">
                    <img :src="imgdizhi + item.speciaCoverPath" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
          <div style="width:19.5%; margin:30px 0 0" v-for="p in parentList" :key="p.id">
            <Detail :mes="p"></Detail>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "../components/detail";
import role from "../minxins/role";
export default {
  components: {
    Detail,
  },
  data() {
    return {
      height: "",
      active: 0,
      title: "",
      name: "全部",
      imgdizhi: "",
      choSection: "",
      choSectionName: "",
      choFenleiId:"",
      choFenlei: "",
      sectionList: [],
      choGrade: "",
      gradeList: [],
      topBannerList:[require('./../../static/img/image.jpeg'),require('./../../static/img/image1.jpeg'),require('./../../static/img/image2.jpeg'),require('./../../static/img/image3.jpg')],
      centerBannerList: [require('./../../static/img/adC.jpeg'),require('./../../static/img/adC1.jpeg'),require('./../../static/img/adC2.jpeg')],
      newList: [], //最新课程
      hotList: [], //最热课程
      parentList: [], //家长列表
      jiazhangfenleiList: [],
      tongzhiList: [],
    };
  },
  mixins: [role],
  mounted() {
    // //console.log(window.sessionStorage.getItem("fileUrl"));
  },
  methods: {
    async init() {
      this.imgdizhi = this.userModule.fileUrl;
      this.height = document.body.clientWidth / 3.7;
      window.addEventListener("resize", this.clientWidth);
      this.getNotice();
      this.getFenlei();
      this.getBanner(1, "3");
      this.getBanner(2, "3");
      await this.getSection();
      // this.getCurriculum(2, "create_time desc");
      // this.choSection=
    },
    // 去课程中心
    goKecheng() {
      this.$router.push({ name: "curriculumCenter" });
    },
    // 去家长中心
    goParent() {
      this.$router.push({ name: "parentsChannel" });
    },
    // 获取通知
    getNotice() {
      let dizhi = `/common/notice/pageList`;
      let primary = { title: "", pageNum: 1, pageSize:3};
      this.$axios.post(dizhi, primary).then((res) => {
        //console.log("获取通知列表", res);
        this.tongzhiList = res.list;
      });
    },
    // 去通知页面
    goTongzhi() {
      this.$router.push({ name: "noticeList" });
    },
    // 家长频道变换
    bianhua(event) {
      this.choFenleiId = this.jiazhangfenleiList[event].id;
      // this.choFenlei = this.jiazhangfenleiList[event].speciaName;
      this.getCurriculum(2, "course_sort asc");
    },
    // 获取家长分类
    getFenlei() {
      let dizhi = `/common/coursespecia/list`;
      let primary = { speciaType: "2", speciaName: "" };
      this.$axios.post(dizhi, primary).then((res) => {
        console.log("获取家长分类",res);
        this.jiazhangfenleiList = res;
        this.choFenlei = this.jiazhangfenleiList[0].speciaName;
        this.getCurriculum(2, "course_sort desc");
      });
    },
    // 获取学段
    async getSection() {
      let dizhi = `/common/section/list`;
      await this.$axios.post(dizhi).then((res) => {
        console.log("获取学段", res);
        this.sectionList = res;
        if (sessionStorage.sectionId) {
          this.choSection = sessionStorage.sectionId;
          this.choSectionName = sessionStorage.sectionName;
        } else {
          res.forEach(even=>{
            if(even.sectionName.indexOf("高中") != -1){
              this.choSection = even.id;
              this.choSectionName = even.sectionName;
              window.sessionStorage.setItem("sectionId", even.id);
              window.sessionStorage.setItem("sectionName",even.sectionName);
            }
          })
        }
        this.getGread();
      });
    },
    // 获取年级
    async getGread() {
      let dizhi = `/common/grade/list`;
      let primary = { sectionId: this.choSection };
      await this.$axios.post(dizhi, primary).then((res) => {
        console.log("根据学期获取年级", res);
        let firstO = { id: "", gradeName: "全部" };
        res.unshift(firstO);
        this.gradeList = res;
        if (sessionStorage.gradeId) {
          this.choGrade = sessionStorage.gradeId;
        } else {
          this.choGrade = "";
          window.sessionStorage.setItem("gradeId", "");
        }
        this.getCurriculum(1, "create_time desc");
        this.getCurriculum(1, "");
        this.getCurriculum(2, "course_sort desc");
      });
    },
    // 获取banner图
    getBanner(type, num) {
      let dizhi = `/common/carousel/list`;
      let primary = { locationType: type, top: num };
      this.$axios.post(dizhi, primary).then((res) => {
        if (type == 1) {
          this.topBannerList = res;
        } else {
          this.centerBannerList = res;
        }
      });
    },
    // banner跳转
    jumpTo(obg) {
      if (obg.carouselType == 1) {
        this.$router.push({
          name: "purchaseDetails",
          params: { id: obg.courseId },
        });
      } else {
        window.open(obg.linkTargetUrl);
      }
    },
    // 获取课程
    getCurriculum(ccf, ob) {
      let dizhi = `/common/course/pageList`;
      let primary = {
        // cSectionId:ccf==1?this.choSection:'',
        cSectionId:'',
        courseClassify: ccf,
        speciaId:ccf==2?this.choFenleiId:'',
        courseSpeciaTeacherName:'',
        // cGradeId:ccf==1?this.choGrade:'',
        cGradeId:'',
        state: 1,
        pageNum: 1,
        pageSize: 10,
        orderBy: ob,
      };
      this.$axios.post(dizhi, primary,{headers:{loadtrue:true}}).then((res) => {
        console.log("获取课程列表", res);
        if (ccf == 1) {
          if (ob.indexOf("create_time") != -1) {
            this.newList = res.list;
          } else {
            this.hotList = res.list;
          }
        } else {
          this.parentList = res.list.slice(0,4);
        }
      });
    },
    handleCommand(command) {
      this.sectionList.forEach((event) => {
        if (event.id == command) {
          this.choSectionName = event.sectionName;
          window.sessionStorage.setItem("sectionName", event.sectionName);
        }
      });
      this.choSection = command;
      window.sessionStorage.setItem("sectionId", command);
      this.choGrade = "";
      window.sessionStorage.setItem("gradeId", "");
      this.getGread();
    },
    btnActive(choId) {
      this.choGrade = choId;
      window.sessionStorage.setItem("gradeId", choId);
      this.$router.push({name:'curriculumCenter',query:{sid:this.choSection,gid:this.choGrade}});
      // this.getCurriculum(1, "create_time desc");
      // this.getCurriculum(1, "");
      // this.getCurriculum(2, "course_sort desc");
    },
    clientWidth() {
      this.height = document.body.clientWidth / 3.7;
      //console.log(this.height);
    },
  },
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  font-size: 14px;
}

.bgc_parent .el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.bgc_parent .el-carousel__item:nth-child(2n) {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
}

.bgc_parent .el-carousel__item:nth-child(2n + 1) {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
}

.bgc_parent .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.bgc_parent .el-carousel__indicator--horizontal {
  padding: 16px 5px 0;
}
.bgc_parent .el-carousel__indicators--outside button {
  background: #fff;
}
.bgc_parent .el-carousel__indicator.is-active button {
  background: #fff;
}
.bgc_parent .el-carousel__item--card.is-active {
  width: 186px;
  height: 230px;
  background: #fff;
  border-radius: 10px;
  transform: translateX(14px) scale(1) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue